import { Language } from "../i18n";
import { getCurrentLanguage } from "../i18n";

export enum FilterUrlConstants {
  Category = 'category',
  TalentOwnerName = 'talentOwnerName'
}
export interface PageTemplateProps {
  data: any;
  pageContext: {
    id: string;
    lang: string;
    languages: string[];
    slug: string;
    alternativeUrls: string[];
  }
}

export interface YouplanetSectionsConfig {
  [key: string]: {
    schema?: string;
    templatePath?: string;
    urls?: { lang: string, value: string }[];
  }
}

export enum YouplanetSections {
  Home = 'home',
  TalentDetail = 'talentDetail',
  TalentList = 'TalentList',
  ProjectDetail = 'ProjectDetail',
  ProjectList = 'ProjectList',
  Producer = 'Producer',
  ProducerDetail = 'ProducerDetail',
  PressDetail = 'PressDetail',
  PressList = 'PressList',
  Network = 'network',
  Agency = 'agency',
  ThankYou = 'thank-you',
  Contact = 'contact',
  Team = 'team',
  DataProtection = 'data-protection',
  NoticeOfConfidentiality = 'notice-of-confidentiality',
  Legal = 'legal',
}

export const youplanetSectionsConfig: YouplanetSectionsConfig = {
  [YouplanetSections.TalentDetail]: {
    schema: 'SanityTalent',
    templatePath: 'TalentDetailTemplate/TalentDetailTemplate.tsx',
  },
  [YouplanetSections.Home]: {
    urls: [
      { lang: Language.Spanish, value: '' },
      { lang: Language.Catalonian, value: '' },
      { lang: Language.English, value: '' },
    ]
  },
  [YouplanetSections.TalentList]: {
    urls: [
      { lang: Language.Spanish, value: 'talentos' },
      { lang: Language.Catalonian, value: `talents` },
      { lang: Language.English, value: `talents` },
    ],
    templatePath: 'TalentListTemplate/TalentListTemplate.tsx',
  },
  [YouplanetSections.ProjectDetail]: {
    schema: 'SanityProject',
    templatePath: 'ProjectDetailTemplate/ProjectDetailTemplate.tsx',
  },
  [YouplanetSections.ProjectList]: {
    urls: [
      { lang: Language.Spanish, value: 'proyectos' },
      { lang: Language.Catalonian, value: 'projectes' },
      { lang: Language.English, value: 'projects' },
    ],
    templatePath: 'ProjectListTemplate/ProjectListTemplate.tsx',
  },
  [YouplanetSections.Producer]: {
    urls: [
      { lang: Language.Spanish, value: 'productora' },
      { lang: Language.Catalonian, value: 'productora' },
      { lang: Language.English, value: 'producing' },
    ],
    templatePath: 'ProducerTemplate/ProducerTemplate.tsx',
  },
  [YouplanetSections.ProducerDetail]: {
    schema: 'SanityProducer',
    templatePath: 'ProducerDetailTemplate/ProducerDetailTemplate.tsx',
  },
  [YouplanetSections.PressDetail]: {
    schema: 'SanityPress',
    templatePath: 'PressDetailTemplate/PressDetailTemplate.tsx',
  },
  [YouplanetSections.PressList]: {
    urls: [
      { lang: Language.Spanish, value: 'prensa' },
      { lang: Language.Catalonian, value: 'premsa' },
      { lang: Language.English, value: 'press' },
    ],
    templatePath: 'PressListTemplate/PressListTemplate.tsx',
  },
  [YouplanetSections.Network]: {
    urls: [
      { lang: Language.Spanish, value: 'network' },
      { lang: Language.Catalonian, value: 'network' },
      { lang: Language.English, value: 'network' },
    ]
  },
  [YouplanetSections.Contact]: {
    urls: [
      { lang: Language.Spanish, value: 'contacto' },
      { lang: Language.Catalonian, value: 'contacte' },
      { lang: Language.English, value: 'contact' },
    ]
  },
  [YouplanetSections.Team]: {
    urls: [
      { lang: Language.Spanish, value: 'equipo' },
      { lang: Language.Catalonian, value: 'equip' },
      { lang: Language.English, value: 'team' },
    ]
  },
  [YouplanetSections.Agency]: {
    urls: [
      { lang: Language.Spanish, value: 'agencia' },
      { lang: Language.Catalonian, value: 'agencia' },
      { lang: Language.English, value: 'agency' },
    ]
  },
  [YouplanetSections.ThankYou]: {
    urls: [
      { lang: Language.Spanish, value: 'gracias' },
      { lang: Language.Catalonian, value: 'gracies' },
      { lang: Language.English, value: 'thank-you' },
    ]
  },
  [YouplanetSections.NoticeOfConfidentiality]: {
    urls: [
      { lang: Language.Spanish, value: 'aviso-de-confidencialidad' },
      { lang: Language.Catalonian, value: 'avis-de-confidencialitat' },
      { lang: Language.English, value: 'notice-of-confidentiality' },
    ]
  },
  [YouplanetSections.DataProtection]: {
    urls: [
      { lang: Language.Spanish, value: 'proteccion-de-datos' },
      { lang: Language.Catalonian, value: 'proteccio-de-dades' },
      { lang: Language.English, value: 'data-protection' },
    ]
  },
  [YouplanetSections.Legal]: {
    urls: [
      { lang: Language.Spanish, value: 'legal' },
      { lang: Language.Catalonian, value: 'legal' },
      { lang: Language.English, value: 'legal' },
    ]
  },
};

export function getSectionSlug(section: YouplanetSections, lang: string, params?: string): string {
  const slugSection = youplanetSectionsConfig[section]?.urls.find(url => url.lang === lang);
  return `/${lang}${slugSection ? `/${slugSection.value}` : ''}/${params ? params : ''}`;
}

export function getSectionConfigByURL(url: string) {
  const urlSections = url.split('/');
  const section = urlSections[2]

  if (!section) {
    return youplanetSectionsConfig[YouplanetSections.Home]
  }
  
  const urls = Object.values(youplanetSectionsConfig).map(section => section.urls).flat();
  const sectionUrl = urls.find(url => url?.value === section);
  const sectionKey = Object.keys(youplanetSectionsConfig).find(key => youplanetSectionsConfig[key]?.urls?.includes(sectionUrl)); 

  return youplanetSectionsConfig[sectionKey];
}
